import React from 'react'
import './header.css'
import Typed from 'react-typed';

function Header() {
  return (
    <div className="main-info">
      <h1>Hey everyone!</h1>
      <Typed 
        strings={[
          " ", 
          "My name is Ofek Ram Nissim", 
          "Junior Full Stack Web Developer", 
          "Also known as an",
          "Freelancer web developer",
          "Front-end developer", 
          "Back-end developer", 
          " ", 
          " "]}
          typeSpeed={70}
          backSpeed={50}
          loop
      />
    </div>
  )
}

export default Header
